export default (value) => `R${Number(value || 0).toLocaleString('en-US')}`;
